import React from 'react';
import {
    Form, Select, Input, InputNumber, Upload, Row, Col, Card, Tag, Divider
} from 'antd';
import { EnvironmentOutlined, UploadOutlined } from '@ant-design/icons';
import { SINISTER_COLORS } from '../../../../../components/ui/colors';

const { Option } = Select;
const { TextArea } = Input;

const POSITION_OPTIONS = [
    { value: 'SUR_LES_LIEUX', label: '📍 Sur les lieux' },
    { value: 'AU_GARAGE', label: '🔧 Au garage' },
    { value: 'A_LA_FOURRIERE', label: '🏛️ À la fourrière' },
    { value: 'DOMICILE_PROPRIETAIRE', label: '🏠 Au domicile du propriétaire' },
];

const AccidentStep = ({
    entites, quartiersData, communesData, loadingQuartiers, selectedLocation, setSelectedLocation,
    typeSinistre, setTypeSinistre, formData, adversaires, adversairePrincipalId,
    onQuartierSelect, onCommuneSelect, form,
}) => (
    <Card style={{ borderRadius: 16, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
        <div style={{ background: SINISTER_COLORS.primary, padding: '10px 30px', margin: '-24px -24px 24px -24px', borderRadius: '6px 6px 0 0' }}>
            <h2 style={{ color: '#fff', margin: 0, fontSize: 20, fontWeight: 'bold' }}>
                <EnvironmentOutlined style={{ marginRight: 12 }} />Détails de l'Accident
            </h2>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)', padding: 16, borderRadius: 12, marginBottom: 20 }}>
            <h4 style={{ color: '#e65100', marginBottom: 16 }}>📍 Localisation et Circonstances</h4>
            <Row gutter={16}>
                <Col xs={24} sm={12}>
                    <Form.Item label={<b>Quartier</b>} name="quartier"
                        help={selectedLocation?.type === 'quartier' && selectedLocation?.commune
                            ? <span style={{ color: '#52c41a', fontSize: 12 }}>📍 {selectedLocation.commune.nom} – {selectedLocation.prefecture?.nom} – {selectedLocation.region?.nom}</span>
                            : null}>
                        <Select placeholder="Rechercher un quartier" onChange={onQuartierSelect} showSearch allowClear loading={loadingQuartiers}
                            filterOption={(input, opt) => (typeof opt.children === 'string' ? opt.children : '').toLowerCase().includes(input.toLowerCase())}
                            onClear={() => { setSelectedLocation(null); form.setFieldsValue({ lieuSinistre: undefined }); }}>
                            {quartiersData.map(q => <Option key={q.id} value={q.id}>{q.nom} ({q.commune?.nom})</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item label={<b>Commune (si quartier non disponible)</b>} name="commune">
                        <Select placeholder="Rechercher une commune" onChange={onCommuneSelect} showSearch allowClear loading={loadingQuartiers}
                            disabled={!!form.getFieldValue('quartier')}
                            filterOption={(input, opt) => (typeof opt.children === 'string' ? opt.children : '').toLowerCase().includes(input.toLowerCase())}
                            onClear={() => { setSelectedLocation(null); form.setFieldsValue({ lieuSinistre: undefined }); }}>
                            {communesData.map(c => <Option key={c.id} value={c.id}>{c.nom} ({c.prefecture?.nom})</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Form.Item label={<b>Lieu exact du sinistre</b>} name="lieu" rules={[{ required: true, message: 'Lieu requis' }]}>
                        <Input placeholder="Adresse exacte du sinistre" />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col xs={24} sm={12}><Form.Item label={<b>Provenance de l'assuré</b>} name="provenance"><Input placeholder="Lieu de départ" /></Form.Item></Col>
                <Col xs={24} sm={12}><Form.Item label={<b>Destination de l'assuré</b>} name="destination"><Input placeholder="Lieu d'arrivée" /></Form.Item></Col>
                <Col xs={24} sm={12}><Form.Item label={<b>Vitesse estimée (km/h)</b>} name="vitesse"><InputNumber min={0} max={200} style={{ width: '100%' }} /></Form.Item></Col>
                <Col xs={24} sm={12}>
                    <Form.Item label={<b>Entité ayant fait le constat</b>} name="entiteConstat">
                        <Select showSearch allowClear style={{ width: '100%' }} placeholder="Sélectionner" options={entites} optionFilterProp="label"
                            filterOption={(i, o) => (o?.label ?? '').toLowerCase().includes((i ?? '').toLowerCase())} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col xs={24} sm={12}>
                    <Form.Item label={<b>Type de dommages subis par l'assuré</b>} name="typeDommageAssure" rules={[{ required: true }]}>
                        <Select style={{ width: '100%' }} placeholder="Sélectionner">
                            <Option value="AUCUN">✅ Aucun dommage</Option>
                            <Option value="MATERIEL">🔧 Matériel uniquement</Option>
                            <Option value="CORPOREL">🏥 Corporel uniquement</Option>
                            <Option value="MIXTE">⚠️ Matériel et Corporel</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item label={<b>Type de dommage général du sinistre</b>} name="typeSinistreGeneral" rules={[{ required: true }]}>
                        <Select style={{ width: '100%' }} placeholder="Sélectionner" onChange={setTypeSinistre}>
                            <Option value="MATERIEL">🔧 Matériel</Option>
                            <Option value="CORPOREL">🏥 Corporel</Option>
                            <Option value="MIXTE">⚠️ Mixte</Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col xs={24}><Form.Item label={<b>Circonstances de l'accident</b>} name="circonstances" rules={[{ required: true }]}><TextArea rows={4} placeholder="Décrire comment l'accident s'est produit…" /></Form.Item></Col>
            </Row>

            {/* Positions véhicules */}
            <div style={{ background: 'rgba(0,0,0,0.03)', border: '1px solid #ffe0b2', borderRadius: 10, padding: '14px 16px', marginBottom: 16 }}>
                <div style={{ fontWeight: 700, color: '#bf360c', marginBottom: 12, fontSize: 14 }}>🚗 Position actuelle de chaque véhicule</div>
                <Row gutter={16}>
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item label={<span><Tag color="blue" style={{ marginRight: 6 }}>Assuré</Tag>{formData?.enginId || 'Véhicule assuré'}</span>}
                            name="positionVehiculeAssure" rules={[{ required: true, message: 'Position requise' }]}>
                            <Select placeholder="Position actuelle" options={POSITION_OPTIONS} />
                        </Form.Item>
                    </Col>
                    {adversaires.filter(a => a.typeAdversaire?.startsWith('VEHICULE')).map((adv, i) => (
                        <Col xs={24} sm={12} md={8} key={adv.id}>
                            <Form.Item
                                label={<span><Tag color={adv.id === adversairePrincipalId ? 'gold' : 'purple'} style={{ marginRight: 6 }}>{adv.id === adversairePrincipalId ? '⭐ Principal' : `Adverse ${i + 1}`}</Tag>{adv.immatriculation || adv.nom || `Adversaire ${i + 1}`}</span>}
                                name={['positionVehiculesAdversaires', String(adv.id)]}>
                                <Select placeholder="Position actuelle" options={POSITION_OPTIONS} />
                            </Form.Item>
                        </Col>
                    ))}
                    {adversaires.filter(a => a.typeAdversaire?.startsWith('VEHICULE')).length === 0 && (
                        <Col xs={24} sm={16}><div style={{ color: '#999', fontSize: 13, fontStyle: 'italic' }}>Les véhicules adverses apparaîtront ici une fois ajoutés dans l'onglet "Partie adverse".</div></Col>
                    )}
                </Row>
            </div>

            <Form.Item label={<b>Observation de l'agent</b>} name="observationEngin">
                <TextArea rows={3} placeholder="État du véhicule assuré, défauts constatés…" />
            </Form.Item>
            {(typeSinistre === 'MATERIEL' || typeSinistre === 'MIXTE') && (
                <Form.Item label={<b>🔧 Description des dégâts matériels sur le véhicule assuré</b>} name="descriptionDegatsMateriels" rules={[{ required: true }]}>
                    <TextArea rows={4} placeholder="Décrire les dégâts matériels sur le véhicule assuré…" />
                </Form.Item>
            )}
            {(typeSinistre === 'CORPOREL' || typeSinistre === 'MIXTE') && (
                <Form.Item label={<b>🏥 Description des lésions corporelles subies par le conducteur</b>} name="descriptionDegatsCorporels" rules={[{ required: true }]}>
                    <TextArea rows={4} placeholder="Décrire les dégâts corporels…" />
                </Form.Item>
            )}
            <Divider />
            <Row gutter={16}>
                <Col xs={24} sm={12}>
                    <Form.Item label={<b>📋 Croquis de l'accident</b>} name="croquis">
                        <Upload listType="picture-card" maxCount={1}><div><UploadOutlined /><div style={{ marginTop: 8 }}>Croquis</div></div></Upload>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item label={<b>📸 Photos de l'accident</b>} name="photos">
                        <Upload listType="picture-card" multiple maxCount={10}><div><UploadOutlined /><div style={{ marginTop: 8 }}>Photos</div></div></Upload>
                    </Form.Item>
                </Col>
            </Row>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)', padding: '14px 16px', borderRadius: 12 }}>
            <h4 style={{ color: '#2e7d32', marginBottom: 12 }}>👤 Témoin (Optionnel)</h4>
            <Row gutter={12} align="bottom">
                <Col xs={24} sm={6}><Form.Item label={<b>Nom</b>} name={['temoin', 'nom']} style={{ marginBottom: 0 }}><Input placeholder="Nom" /></Form.Item></Col>
                <Col xs={24} sm={6}><Form.Item label={<b>Prénom</b>} name={['temoin', 'prenom']} style={{ marginBottom: 0 }}><Input placeholder="Prénom" /></Form.Item></Col>
                <Col xs={24} sm={6}><Form.Item label={<b>Téléphone</b>} name={['temoin', 'telephone']} style={{ marginBottom: 0 }}><Input placeholder="Téléphone" /></Form.Item></Col>
                <Col xs={24} sm={6}><Form.Item label={<b>Adresse</b>} name={['temoin', 'adresse']} style={{ marginBottom: 0 }}><Input placeholder="Adresse" /></Form.Item></Col>
            </Row>
        </div>
    </Card>
);

export default AccidentStep;
